module.exports = __webpack_public_path__ + "img/banner01-mobile-v2.5c7c3930.png";